import store from 'services/store';
import setUser from 'services/store/user/actions/setUser';

const setUserInfo = async authInfo => await store.dispatch(setUser(authInfo.user));

export default setUserInfo;
